import { createAxios } from '../../lib/axiosFactory';
import { errorParser } from '../../lib/response/errorParser';
import { InternalComplianceReport } from '../../lib/interfaces/internalComplianceReport';
import { calculatePercantage } from '../././../plugins/number-filters';
export const state = {
  internalComplianceReportRecords: [] as InternalComplianceReport[]
};

export const getters = {};

export const actions = {
  async fetchInternalComplianceReport({ commit }: any, payload: any) {
    try {
      const response = await createAxios().get(
        'backend/mobiz-admin-compliance-report-show',
        {
          params: {
            reportDate: payload.reportDate,
            businessRegion: payload.businessRegion,
            ...(payload.format && { format: payload.format })
          }
        }
      );
      if (payload.format) {
        return {
          success: true,
          errors: {},
          body: response.data
        };
      } else {
        const records = response.data.data.attributes.adminComplianceReport.map(
          element =>
            ({
              phoneNumber: element.client.messagingSendingPhoneNumber,
              email: element.userEmail,
              companyName: element.client.companyName,
              campaignMessages: element.messages.campaignMessagesCount,
              allCampaignMessagesSentPerClient:
                element.messages.allCampaignMessagesSentPerClient,
              automatedMessages: element.messages.automatedMessagesCount,
              totalUnknown: element.messages.unknownMessagesCount,
              delivery:
                element.messages.deliveredMessagesCount +
                ' | ' +
                calculatePercantage(
                  element.messages.deliveredMessagesCount,
                  element.messages.automatedMessagesCount +
                    element.messages.campaignMessagesCount
                ),
              totalUnsubscribers:
                element.unsubscribes.unsubscribedCount +
                element.unsubscribes.campaignUnsubscribedCount +
                ' | ' +
                calculatePercantage(
                  element.unsubscribes.unsubscribedCount +
                    element.unsubscribes.campaignUnsubscribedCount,
                  element.messages.deliveredMessagesCount
                ),
              campaignUnsubscribers:
                element.unsubscribes.campaignUnsubscribedCount +
                ' | ' +
                calculatePercantage(
                  element.unsubscribes.campaignUnsubscribedCount,
                  element.messages.deliveredMessagesCount
                ),
              totalQuietHoursCancelledMessages:
                element.messages.quietHoursCancelledMessages +
                ' | ' +
                calculatePercantage(
                  element.messages.quietHoursCancelledMessages,
                  element.messages.campaignMessagesCount
                )
            } as InternalComplianceReport)
        );
        return {
          success: true,
          errors: {},
          body: { records: records }
        };
      }
    } catch (error) {
      return {
        success: false,
        errors: errorParser(error),
        body: error.response?.data ?? error.response
      };
    }
  }
};
